import styled from "@emotion/styled";
import { lnbAndFloating } from "@/themes/device";

export const DesktopWrapper = styled.div`
  display: none;
  ${lnbAndFloating} {
    display: initial;
    width: 100%;
    position: fixed;
    bottom: 100px;
    z-index: 500;
  }
`;

export const Desktop = styled.div`
  display: none;
  ${lnbAndFloating} {
    cursor: pointer;
    height: 90px;
    display: initial;
    position: fixed;
    bottom: 100px;
    right: 1%;
    max-width: initial;
    padding: 0;
  }
`;

export const MobileWrapper = styled.div`
  width: 100%;
  position: fixed;
  bottom: 70px;
  z-index: 500;
  height: 80px;
  ${lnbAndFloating} {
    display: none;
  }
`;

export const Mobile = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 328px;
  ${lnbAndFloating} {
    display: none;
  }
`;

export const EmptyDiv = styled.div`
  width: 10px;
  height: 10px;
`;

export const MobileImage = styled.div`
  cursor: pointer;
  filter: drop-shadow(0px 13.5px 16.2px rgba(20, 22, 23, 0.24));
`;
